<template>

    <div class="whiteContainer whiteTableBox">
        <div class="tableContainer">
            <div
                v-if="$parent.inProgress == true"
                style="position: relative; height: 770px"
            >
                <svg
                    style="
                        margin: 0;
                        position: absolute;
                        top: 50%;
                        left: 50%;
                        -ms-transform: translate(-50%, -50%);
                        transform: translate(-50%, -50%);
                    "
                    viewBox="25 25 50 50"
                    class="loader-svg"
                >
                    <circle
                        class="loader-path"
                        cx="50"
                        cy="50"
                        r="20"
                        fill="none"
                        stroke="#1990d4"
                        stroke-width="2"
                    />
                </svg>
            </div>
            <div v-if="$parent.inProgress == false" class="accordion">
                <table class="mainTable" id="dealsTable">
                    <thead>
                        <tr class="mainTable__row mainTable__row--header">
                            <th class="mainTable__cell mainTable__cell--header">
                                מספר סידורי
                            </th>
                            <th class="mainTable__cell mainTable__cell--header">
                                כתובת
                            </th>
                            <th class="mainTable__cell mainTable__cell--header">
                                שטח במ"ר
                            </th>
                            <th class="mainTable__cell mainTable__cell--header">
                                תאריך העסקה
                            </th>
                            <th class="mainTable__cell mainTable__cell--header">
                                מחיר העסקה
                            </th>
                            <th
                                class="mainTable__cell mainTable__cell--header hideMob"
                            >
                                גוש/חלקה/תת-חלקה
                            </th>
                            <th
                                class="mainTable__cell mainTable__cell--header hideMob"
                            >
                                סוג נכס
                            </th>
                            <th class="mainTable__cell mainTable__cell--header">
                                חדרים
                            </th>
                            <th
                                class="mainTable__cell mainTable__cell--header hideMob"
                            >
                                קומה
                            </th>
                            <th
                                class="mainTable__cell mainTable__cell--header hideMob"
                            >
                                מגמת שינוי
                            </th>
                            <th
                                class="mainTable__cell mainTable__cell--header"
                            ></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(deal, index) in selectedDeals">
                            <tr
                                :key="'1tr-' + deal.row_id"
                                class="mainTable__row"
                                @click="$parent.toggleCollapse(index)"
                            >
                                <td @click="$parent.zoomRow(deal)" class="mainTable__cell" data-head="מספר סידורי">
                                    {{ deal.row_id }}
                                </td>
                                <td @click="$parent.zoomRow(deal)" class="mainTable__cell" data-head="כתובת">
                                    <button
                                        @click="deal.addressId !== 0 && $parent.updateUrl(deal.addressId)"
                                        v-on:click="!$parent.PageIsAddressOrParcel() ? () => $parent.updateUrl(deal.addressId) : null"
                                        type="button"
                                        class="nLink"
                                        :style="deal.addressId > 0 && !$parent.PageIsAddressOrParcel() ? 'color: #0d3efb; font-size: 90%; font-weight: bold' : 'font-size: 90%; font-weight: bold'"
                                    >
                                        {{ deal.address ? deal.address : 'ללא כתובת'}}
                                    </button>
                                </td>
                                <!-- Add other table cells based on your deal object properties -->
                                <td @click="$parent.zoomRow(deal)" class="mainTable__cell" data-head='שטח במ"ר'>
                                    {{ deal.assetArea ? deal.assetArea : 'לא ידוע' }}
                                </td>
                                <td @click="$parent.zoomRow(deal)" class="mainTable__cell" data-head="תאריך עסקה">
                                    {{ deal.dealDate }}
                                </td>
                                <td @click="$parent.zoomRow(deal)" class="mainTable__cell" data-head="מחיר העסקה">
                                    <span class="currency"></span>{{ deal.dealAmount }}
                                </td>
                                <!-- Add other cells based on your deal object properties -->
                                <td @click="$parent.zoomRow(deal)"
                                    class="mainTable__cell"
                                    :data-head="$parent.parcel_dataHead()"
                                >
                                    <button
                                        @click="$parent.updateUrlParcel(deal.polygonId)"
                                        type="button"
                                        :class="[
                                            deal.addressId > 0  ?  'addressText' : '',
                                            'nLink',
                                        ]"
                                        :style="deal.addressId == 0 ? 'color: #0d3efb; font-size: 90%; font-weight: bold' : ''"
                                    >
                                        {{ deal.parcelNum }}
                                    </button>
                                </td>
                                <td @click="$parent.zoomRow(deal)" class="mainTable__cell" data-head="סוג נכס">
                                    {{ deal.dealNature ? deal.dealNature : 'לא ידוע' }}
                                </td>
                                <td @click="$parent.zoomRow(deal)" class="mainTable__cell" data-head="חדרים">
                                    {{ deal.roomNum ? deal.roomNum : 'לא ידוע' }}
                                </td>
                                <td  @click="$parent.zoomRow(deal)" class="mainTable__cell" data-head="קומה">
                                    {{ deal.floor ? deal.floor : 'לא ידוע' }}
                                </td>
                                <td @click="$parent.zoomRow(deal)"
                                    class="mainTable__cell hideMob"
                                    data-head="מגמת שינוי"
                                >
                                    
                                <div class="icon-text-container">
                                    <div 
                                        v-if="deal.trend_text" 
                                        v-html="$parent.upOrDown_deal(deal.trend_text)" 
                                        class="arrowIcon"
                                        :class="$parent.upOrDown_color(deal.trend_text)">
                                    </div>
                                    
                                    <span :style="$parent.upOrDown_color(deal.trend_text)">
                                        {{ deal.trend_text }}
                                    </span>
                                </div>

                                </td>

                                <div v-if="deal.trend_text"
                                data-head="מגמת שינוי"
                                class="mainTable__cell hideDesktop icon-text-container"
                                style="justify-content: flex-start;"
                            >
                    
                                <div 
                                    v-if="deal.trend_text" 
                                    v-html="$parent.upOrDown_deal(deal.trend_text)" 
                                    class="arrowIcon"
                                    :class="$parent.upOrDown_color(deal.trend_text)">
                                </div>
                                
                                <span :style="$parent.upOrDown_color(deal.trend_text)">
                                    {{ deal.trend_text }}
                                </span>
                            </div>
                                <!-- Add cells for other properties -->
                                <!-- ... -->
                                <td
                                    class="mainTable__cell arrowRow"
                                >
                                    <button type="button" class="collapseArrow">
                                        <span v-if="$parent.selectedRow !== null && $parent.selectedRow == index" class="arrow"></span>
                                        <span v-else class="arrow up"></span>
                                    </button>
                                </td>
                            </tr>
                            <!-- Additional details row with transition -->

                            <transition
                                mode="out-in"
                                name="fade"
                                :key="'trans-' + index"
                            >
                                <tr
                                    v-if="$parent.selectedRow !== null && $parent.selectedRow == index"
                                    :key="'2tr-' + index"
                                    class="mainTable__row mainTable__row--collapse"
                                >
                                    <td colspan="9">
                                        <div class="collapsedRowContainer">
                                            <div class="innerTablesContainer">
                                                <div class="hideDesk infoTable">
                                                    <h3 class="innerTableTitle">
                                                        נתונים נוספים
                                                    </h3>
                                                    <div class="infoMob innerTableWrap">
                                                        <!-- <div
                                                            data-head="סוג נכס"
                                                            class="mainTable__cell"
                                                        >
                                                            {{ deal.dealNature ? deal.dealNature : 'לא ידוע' }}
                                                        </div>
                                                        <div
                                                            data-head="קומה"
                                                            class="mainTable__cell"
                                                        >
                                                            {{ deal.floor ? deal.floor : 'לא ידוע' }}
                                                        </div> -->
                                                        <div
                                                            data-head="שנת בנייה"
                                                            class="mainTable__cell"
                                                        >
                                                        {{ deal.yearBuilt  !== 0 ? deal.yearBuilt : 'לא ידוע' }}
                                                        </div>
                                                        <div
                                                            data-head='מחיר למ"ר'
                                                            class="mainTable__cell"
                                                        >
                                                          
                                                    {{ deal.priceSM ? deal.priceSM.toLocaleString() + ' ₪' : 'לא ידוע' }}
                                                          
                                                        </div>
                                                        <!-- <div
                                                            data-head="חלקה/תת חלקה"
                                                            class="mainTable__cell"
                                                        >
                                                            <span class="addressText">{{
                                                                deal.parcelNum
                                                            }}</span>
                                                        </div> -->
                                                        <!-- <div v-if="deal.trend_text"
                                                            data-head="מגמת שינוי"
                                                            class="mainTable__cell icon-text-container"
                                                            style="justify-content: flex-start;"
                                                        >
                                                
                                                            <div 
                                                                v-if="deal.trend_text" 
                                                                v-html="$parent.upOrDown_deal(deal.trend_text)" 
                                                                class="arrowIcon"
                                                                :class="$parent.upOrDown_color(deal.trend_text)">
                                                            </div>
                                                            
                                                            <span :style="$parent.upOrDown_color(deal.trend_text)">
                                                                {{ deal.trend_text }}
                                                            </span>
                                                        </div> -->
                                                    </div>
                                                </div>
                                                <div class="infoTable hideMob">
                                                    <h3 class="innerTableTitle">
                                                        נתונים נוספים
                                                    </h3>
                                                    <div class="innerTableWrap">
                                                        <div class="innerTable">
                                                            <div
                                                                class="innerTable__row innerTable__row--header"
                                                            >
                                                                <div
                                                                    class="innerTable__cell innerTable__cell--header"
                                                                >
                                                                    שנת בנייה
                                                                </div>
                                                                <div
                                                                    class="innerTable__cell innerTable__cell--header"
                                                                >
                                                                    מחיר למ"ר
                                                                </div>
                                                                <div
                                                                    class="innerTable__cell innerTable__cell--header"
                                                                >
                                                                    קומות
                                                                </div>
                                                            </div>
                                                            <div>
                                                                <div class="innerTable__row">
                                                                    <div class="innerTable__cell">
                                                                        {{ deal.yearBuilt }}
                                                                    </div>
                                                                    <div class="innerTable__cell">
                                                                        {{ deal.priceSM ? deal.priceSM.toLocaleString() + ' ₪' : 'לא ידוע' }}																					</div>
                                                                    <div class="innerTable__cell">
                                                                        {{ deal.buildingFloors }}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    v-if="deal.prevDeals.length > 0"
                                                    class="prevDealsTable"
                                                >
                                                    <h3 class="innerTableTitle">
                                                        עסקאות קודמות לנכס
                                                    </h3>
                                                    <div class="innerTableWrap">
                                                        <div class="innerTable">
                                                            <div
                                                                class="innerTable__row innerTable__row--header"
                                                            >
                                                                <div
                                                                    class="innerTable__cell innerTable__cell--header"
                                                                >
                                                                    תאריך עסקה
                                                                </div>
                                                                <div
                                                                    class="innerTable__cell innerTable__cell--header"
                                                                >
                                                                    מחיר עסקה
                                                                </div>
                                                            </div>
                                                            <div
                                                                v-for="(pd, index) in deal.prevDeals"
                                                                :key="index"
                                                                class="scrollbar-container innerTable__body ps ps__rtl"
                                                            >
                                                                <div class="innerTable__row">
                                                                    <div class="innerTable__cell">
                                                                        {{ pd.dealDate }}
                                                                    </div>
                                                                    <div class="innerTable__cell">
                                                                        {{ pd.dealAmount.toLocaleString() }} ₪
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="ps__rail-x"
                                                                    style="left: 0px; bottom: 0px"
                                                                >
                                                                    <div
                                                                        class="ps__thumb-x"
                                                                        tabindex="0"
                                                                        style="left: 0px; width: 0px"
                                                                    ></div>
                                                                </div>
                                                                <div
                                                                    class="ps__rail-y"
                                                                    style="top: 0px; right: -15px"
                                                                >
                                                                    <div
                                                                        class="ps__thumb-y"
                                                                        tabindex="0"
                                                                        style="top: 0px; height: 0px"
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    v-if="deal.ownership.length > 0"
                                                    class="ownershipTable"
                                                >
                                                    <h3 class="innerTableTitle">
                                                        חלוקת בעלות הנכס
                                                    </h3>
                                                    <div class="innerTableWrap">
                                                        <div class="innerTable">
                                                            <div
                                                                class="innerTable__row innerTable__row--header"
                                                            >
                                                                <div
                                                                    class="innerTable__cell innerTable__cell--header small"
                                                                ></div>
                                                                <div
                                                                    class="innerTable__cell innerTable__cell--header"
                                                                >
                                                                    חלק נמכר
                                                                </div>
                                                                <div
                                                                    class="innerTable__cell innerTable__cell--header"
                                                                >
                                                                    מחיר
                                                                </div>
                                                            </div>
                                                            <div
                                                                v-for="(
                                                                    owner, index
                                                                ) in deal.ownership"
                                                                :key="index"
                                                                class="scrollbar-container innerTable__body ps ps__rtl"
                                                            >
                                                                <div class="innerTable__row">
                                                                    <div class="innerTable__cell small">
                                                                        {{ index + 1 }}
                                                                    </div>
                                                                    <div class="innerTable__cell">
                                                                        {{ owner.proportion }}%
                                                                    </div>
                                                                    <div class="innerTable__cell">
                                                                        {{ owner.price.toLocaleString() }} ₪
                                                                    </div>
                                                                </div>
                                                                <div
                                                                    class="ps__rail-x"
                                                                    style="left: 0px; bottom: 0px"
                                                                >
                                                                    <div
                                                                        class="ps__thumb-x"
                                                                        tabindex="0"
                                                                        style="left: 0px; width: 0px"
                                                                    ></div>
                                                                </div>
                                                                <div
                                                                    class="ps__rail-y"
                                                                    style="top: 0px; right: -15px"
                                                                >
                                                                    <div
                                                                        class="ps__thumb-y"
                                                                        tabindex="0"
                                                                        style="top: 0px; height: 0px"
                                                                    ></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </transition>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="tableSummary">
                <p class="plainText">נמצאו {{ $parent.total_rows }} עסקאות</p>
                <ul class="pagination">
                    <li v-show="$parent.currentPage > 1">
                        <button
                            @click="$parent.goBack()"
                            class="arrows backBtn"
                            type="button"
                        >
                            <div class="arrowWrap">
                                <span class="long"></span>
                            </div>
                            <span class="text">הקודם</span>
                        </button>
                    </li>
                    <li class="paginate">
                        {{ $parent.currentPage }} / {{ $parent.totalPages }}
                    </li>
                    <li>
                        <button
                            id="next"
                            v-show="$parent.currentPage < $parent.totalPages"
                            @click="$parent.go()"
                            class="arrows nextBtn"
                            type="button"
                            :disabled="$parent.currentPage >= $parent.totalPages"
                        >
                            <span class="text">הבא</span>
                            <div class="arrowWrap"><span class="long"></span></div>
                        </button>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: "TableBox",
    data() {

        return {
            
        };
    },
    computed: {
        selectedDeals() {
            //console.log('this.$parent.$options.name', this.$parent.$options.name);
            // if parent name == 'DealsPage.vue'
            if (this.$parent.$options.name == 'DealsPage') {
                return this.$parent.selectedDeals;
            }
            if (this.$parent.$options.name == 'AdditionalDeals') {
                //console.log('AdditionalDeals');
                return this.$parent.currentTransactions;
            }   
            return this.$parent.selectedDeals;
        },
    },
      
};

</script>


<style scoped>
    /* Add your styles here */
    @media screen and (min-width: 768px) {
        .hideDesktop {
            display: none;
        }
        
    }

    @media screen and (max-width: 767px) {
        .hideMob {
            display: none;
        }
    }
</style>